import { Link as ScrollLink } from 'react-scroll';
// material
import { styled } from '@material-ui/core/styles';
import { Link, Divider, Container, Typography, Stack } from '@material-ui/core';
//
import Logo from '../../components/logos/Logo';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: '1.875rem',
  position: 'relative',
  backgroundColor: theme.palette.grey['100']
}));

// ----------------------------------------------------------------------

export default function DashboardFooter() {
  return (
    <RootStyle>
      <Container maxWidth="xl">
        <Stack direction={{ xs: 'column', lg: 'row' }} spacing={5} justifyContent="space-between">
          <Stack alignItems={{ xs: 'center', lg: 'start' }}>
            <ScrollLink to="move_top" spy smooth>
              <Logo color="dark" />
            </ScrollLink>
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={5} justifyContent="center">
            <Stack alignItems={{ xs: 'center', sm: 'start' }} justifyContent="start">
              <Typography variant="subtitle1" color="grey.600" fontWeight="700" sx={{ mb: '1.5rem' }}>
                PLATAFORMA
              </Typography>
              <Link href={process.env.REACT_APP_CANDIDATE_URL} target="_blank" sx={{ mb: '1rem' }}>
                <Typography variant="subtitle1" color="primary" fontWeight="700">
                  Para Profissionais
                </Typography>
              </Link>
              <Typography
                variant="subtitle1"
                color="primary"
                fontWeight="700"
                sx={{ mb: '1rem', cursor: 'pointer' }}
                onClick={() => window.location.reload()}
              >
                Para Empresas
              </Typography>
              <Link href="https://web.whatsapp.com/send?phone=558488734257" target="_blank" sx={{ mb: '2.125rem' }}>
                <Typography variant="subtitle1" color="primary" fontWeight="700">
                  Fale Conosco
                </Typography>
              </Link>
            </Stack>
            <Stack alignItems={{ xs: 'center', sm: 'start' }} justifyContent="start">
              <Typography variant="subtitle1" color="grey.600" fontWeight="700" sx={{ mb: '1.5rem' }}>
                LEGAL
              </Typography>
              <Link href="/static/files/POLÍTICA_DE_PRIVACIDADE.pdf" target="_blank">
                <Typography variant="subtitle1" color="primary" fontWeight="700" sx={{ mb: '1rem' }}>
                  Política de Privacidade
                </Typography>
              </Link>
              <Link href="/static/files/TERMOS_DE_USO_.pdf" target="_blank">
                <Typography variant="subtitle1" color="primary" fontWeight="700" sx={{ mb: '1rem' }}>
                  Termos de Uso
                </Typography>
              </Link>
            </Stack>
            <Stack alignItems={{ xs: 'center', sm: 'start' }} justifyContent="start" spacing={3}>
              <Typography variant="subtitle1" color="grey.600" fontWeight="700">
                CONTATO
              </Typography>
              <Typography variant="subtitle1" fontWeight="400" sx={{ mb: '2.125rem' }}>
                atendimento@crea-rn.org.br
              </Typography>
              <Stack alignItems="center">
                <Typography sx={{ mb: '1.5rem', fontFamily: 'Red Hat Display', fontWeight: '500', fontSize: '18px' }}>
                  Siga-nos nas redes sociais
                </Typography>
                <Stack direction="row" spacing={4} sx={{ ml: '1rem' }}>
                  <Link href="https://www.instagram.com/crearn?igsh=MTR6Y29iZHVkdGZqNg==" target="_blank">
                    <img src="/static/icons/insta_icon.png" alt="insta" />
                  </Link>
                  <Link href="https://www.linkedin.com/company/crea-rn/" target="_blank">
                    <img src="/static/icons/linkedin_icon.png" alt="linkedin" />
                  </Link>
                  <Link href="https://youtube.com/@oficialcrea-rn?si=ArCi07cRszCdYhRK" target="_blank">
                    <img src="/static/icons/youtube_icon.svg" alt="Youtube" />
                  </Link>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Container>
      <Divider sx={{ mb: '0.75rem', mt: '1.313rem' }} />
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', lg: 'row' }}
          spacing={{ xs: 1, lg: 23.5 }}
          alignItems="center"
          sx={{ pb: '0.75rem' }}
        >
          <Typography variant="subtitle1" fontWeight="500" textAlign="center">
            HUB CREA RN © {new Date().getFullYear()} | Todos os direitos reservados.
          </Typography>
          <Typography variant="subtitle1" fontWeight="500" textAlign="center">
            Empresa em adequação à Lei Geral de Proteção de Dados (LGPD).
          </Typography>
        </Stack>
      </Container>
    </RootStyle>
  );
}
